import { AuthApiError, OAuthError } from '@okta/okta-auth-js';
import { AxiosError } from 'axios';

const IGNORED_ERROR_TYPES = [AuthApiError, OAuthError, AxiosError];
const IGNORED_STATUS_CODES = [400, 404, 422];

export const shouldIgnoreError = error => {
  // Check for ignored error types
  if (IGNORED_ERROR_TYPES.some(errorType => error instanceof errorType)) {
    return true;
  }

  // Check for ignored status codes
  if (
    error?.response?.status &&
    IGNORED_STATUS_CODES.includes(error.response.status)
  ) {
    return true;
  }

  return false;
};
